import App from "./App";
import ReactDOM from "react-dom";
import React, { Suspense } from "react";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from 'react-router-dom';
import Spinner from "./components/spinner-component/Spinner";


const app = (
    <BrowserRouter>
        <CookiesProvider>
            <Suspense fallback={<div className="text-center mt-5"><Spinner /></div>}>
                <App />
            </Suspense>
        </CookiesProvider>
    </BrowserRouter>
)

ReactDOM.render(app, document.getElementById('root'));